import React, { useContext } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Redirect, matchPath } from 'react-router'

// Constants
import { OVERLAY_HELPERS } from 'src/constants/navigation'

// Selectors
import { selectCustomerHasSponsor } from 'src/store/selectors/customerProfile'
import {
  selectSponsorshipFullName,
  selectSponsorshipPhone,
  selectSponsorshipNmls,
} from 'src/store/selectors/sponsorship'
import {
  selectRefiRequested,
  selectRefiRequestSuccess,
  selectRefiRequestFailure,
} from 'src/store/selectors/refinance'
import { selectShouldRenderRefiOptions } from 'src/store/selectors/display'

// Components
import { ActiveOverlayContext } from 'src/Components/shared/Routing/OverlayContext'
import { If, Unless, Text, InlineBulletedList, Page } from 'src/Components'
import Phone from 'src/Components/shared/Phone'
import NMLS from 'src/Components/shared/NMLS'
import { RedirectToHomeDigest } from 'src/Components/shared/Navigation'

import RefiRateRequestPanelInfo from './RefiRateRequestPanelInfo'
import RefiRateRequestPanelSuccess from './RefiRateRequestPanelSuccess'
import RefiRateRequestPanelFailure from './RefiRateRequestPanelFailure'

// Styles
import styles from './RefiRateRequestPanel.module.scss'

export const RefiRateRequestPanel = ({ sendRequest }) => {
  const { doNavBack } = useContext(ActiveOverlayContext)

  const requested = useSelector(selectRefiRequested)
  const success = useSelector(selectRefiRequestSuccess)
  const failure = useSelector(selectRefiRequestFailure)

  const hasSponsor = useSelector(selectCustomerHasSponsor)
  const hasRefiOptions = useSelector(selectShouldRenderRefiOptions)
  const refiPathMatch =
    matchPath(window.location.pathname, {
      path: OVERLAY_HELPERS.refinance.matchPath,
    }) || {}

  const sponsorFullName = useSelector(selectSponsorshipFullName)
  const sponsorPhone = useSelector(selectSponsorshipPhone)
  const sponsorNmls = useSelector(selectSponsorshipNmls)

  if (!hasSponsor) {
    if (hasRefiOptions && refiPathMatch.url) {
      return <Redirect to={refiPathMatch.url} />
    }

    return <RedirectToHomeDigest />
  }

  return (
    <Page>
      <Page.Body className={styles.body}>
        <Unless condition={success || failure}>
          <RefiRateRequestPanelInfo
            doSubmit={sendRequest}
            didSubmit={requested}
          />
        </Unless>
        <If condition={success}>
          <RefiRateRequestPanelSuccess doSubmit={() => doNavBack()} />
        </If>
        <If condition={failure}>
          <RefiRateRequestPanelFailure doSubmit={() => doNavBack()} />
        </If>
        <Text
          element='div'
          className={styles.footer}
          variant='neutralCool'
          variantCount='700'
          size='s'
        >
          <InlineBulletedList>
            <span>{sponsorFullName}</span>
            <Phone value={sponsorPhone} />
            <NMLS value={sponsorNmls} />
          </InlineBulletedList>
        </Text>
      </Page.Body>
    </Page>
  )
}

RefiRateRequestPanel.propTypes = {
  sendRequest: PropTypes.func.isRequired,
}

export default RefiRateRequestPanel
